import React, { useEffect, useState } from 'react';
import {
  Alert,
  AlertDescription,
  Button,
  Center,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  FormControl,
  FormLabel,
  HStack,
  Icon,
  IconButton,
  Link,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { FiFile } from 'react-icons/all';
import { Stack } from '@chakra-ui/layout';
import { useHistory } from 'react-router-dom';
import { Button as ChakraButton } from '@chakra-ui/button/dist/types/button';
import { Heading, Input, Table } from '~/components';
import { useCertificateContracts } from '~/hooks/useZeroCarbon/useGroupZeroCarbon';
import { openLinkInNewTab } from '~/utils/openLinkInNewTab';
import { replaceParameters } from '~/utils/replaceParamaters';
import { ROUTER_PATHS } from '~/constants';

export const CertificateContractsDialog: React.FC<{
  id_projeto_co2: string;
  codigo_certificado: string;
  link_certificado: string;
}> = ({ id_projeto_co2, codigo_certificado = '', link_certificado = '' }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const { data: contratos, isFetching: isFetchingContratos } =
    useCertificateContracts(id_projeto_co2);
  const history = useHistory();

  const handleClose = () => {
    onClose();
  };

  const handleOpen = () => {
    onOpen();
  };

  return (
    <>
      <IconButton
        aria-label="Contratos"
        icon={<Icon as={FiFile} />}
        onClick={handleOpen}
      />
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={handleClose}
        size="xl"
        closeOnOverlayClick={false}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader mb={4}>
            <Heading fontSize="xl">Contratos do certificado</Heading>
          </DrawerHeader>

          <DrawerBody>
            <Stack gridGap={3}>
              <FormControl>
                <FormLabel fontSize="14px">Certificado:</FormLabel>
                <Text
                  sx={{
                    textDecor: 'underline',
                    fontWeight: 'bold',
                    fontSize: '12px',
                    cursor: 'pointer',
                  }}
                  onClick={() => openLinkInNewTab(`${link_certificado}`)}
                >
                  {codigo_certificado}
                </Text>
              </FormControl>
              <TableContainer>
                <Table type="secondary">
                  <Thead>
                    <Tr>
                      <Th>N° CONTRATO SAP</Th>
                      <Th>N° DO TERMO</Th>
                      <Th>EMPRESA/GRUPO</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {contratos?.length ? (
                      contratos.map(it => (
                        <Tr key={it.nu_termo}>
                          <Td>
                            <Button
                              variant="link"
                              fontWeight="bold"
                              color="#78797A"
                              _hover={{
                                color: 'gray.900',
                                textDecoration: 'underline',
                              }}
                              onClick={() =>
                                history.push(
                                  replaceParameters(
                                    ROUTER_PATHS.PORTAL.CONCTRACT_DETAIL,
                                    String(it.id_contrato),
                                  ),
                                )
                              }
                              fontSize="15px"
                              textDecoration="underline"
                            >
                              {it.nu_contrato}
                            </Button>
                          </Td>
                          <Td>{it.nu_termo}</Td>
                          <Td>
                            {it.nm_grupoeconomico}
                            <Text fontSize="12px">{it.nm_razaosocial}</Text>
                          </Td>
                        </Tr>
                      ))
                    ) : (
                      <Tr>
                        <Td colSpan={7} textAlign="center">
                          {' '}
                          Nenhum contrato.
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </Stack>
          </DrawerBody>

          <DrawerFooter>
            <Button variant="solid" onClick={() => handleClose()}>
              Cancelar
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};
